import React, { useState } from 'react';
import LoanInputForm from './components/LoanInputForm';
import RepaymentChart from './components/RepaymentChart';
import BalanceChart from './components/BalanceChart';
import './App.css';

function App() {
  const [calculationData, setCalculationData] = useState(null);
  const [unpaidInterestOccurred, setUnpaidInterestOccurred] = useState(false);

  return (
    <div className="App">
      <LoanInputForm
        setCalculationData={setCalculationData}
        setUnpaidInterestOccurred={setUnpaidInterestOccurred}
      />
      {unpaidInterestOccurred && (
        <div className="alert">
          未払い利息が発生しています。詳細については専門家にご相談ください。
        </div>
      )}
      {calculationData && (
        <>
          {/* 総返済額と総利息額を表示 */}
          <div className="totals">
            <h2>総返済額と総利息額</h2>
            <p>
              総返済額: ¥{Math.round(calculationData.totalPaymentAmount).toLocaleString()}
            </p>
            <p>
              総利息額: ¥{Math.round(calculationData.totalInterestPaid).toLocaleString()}
            </p>
            
            {/* 詳細手数料情報を表示 */}
            {calculationData.feeStructure && (
              <>
                <h3>手数料詳細</h3>
                <p>
                  手数料構造: {calculationData.feeStructure === 'upfrontFee' ? '融資手数料型' : '融資金利上乗せ型'}
                </p>
                <p>
                  初期手数料: ¥{Math.round(calculationData.upfrontFee).toLocaleString()}
                </p>
                {calculationData.plannedRepaymentMonths && (
                  <>
                    <p>
                      計画保有期間: {Math.round(calculationData.plannedRepaymentMonths / 12 * 10) / 10}年
                    </p>
                    <p>
                      売却時残債: ¥{Math.round(calculationData.remainingBalanceAtSale).toLocaleString()}
                    </p>
                    <p>
                      繰上返済手数料: ¥{Math.round(calculationData.earlyRepaymentPenalty).toLocaleString()}
                    </p>
                    <p style={{fontWeight: 'bold', color: '#d63384'}}>
                      総コスト（手数料込み）: ¥{Math.round(calculationData.totalCostWithFees).toLocaleString()}
                    </p>
                  </>
                )}
                
                {/* 比較データがある場合は表示 */}
                {calculationData.comparisonData && (
                  <>
                    <h4>手数料構造比較</h4>
                    <div style={{display: 'flex', gap: '20px'}}>
                      <div style={{flex: 1, padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px'}}>
                        <h5>融資手数料型</h5>
                        <p>初期手数料: ¥{Math.round(calculationData.feeStructure === 'upfrontFee' ? calculationData.upfrontFee : calculationData.comparisonData.upfrontFee).toLocaleString()}</p>
                        <p>総コスト: ¥{Math.round(calculationData.feeStructure === 'upfrontFee' ? calculationData.totalCostWithFees : calculationData.comparisonData.totalCostWithFees).toLocaleString()}</p>
                      </div>
                      <div style={{flex: 1, padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px'}}>
                        <h5>融資金利上乗せ型</h5>
                        <p>初期手数料: ¥{Math.round(calculationData.feeStructure === 'rateMarkup' ? calculationData.upfrontFee : calculationData.comparisonData.upfrontFee).toLocaleString()}</p>
                        <p>総コスト: ¥{Math.round(calculationData.feeStructure === 'rateMarkup' ? calculationData.totalCostWithFees : calculationData.comparisonData.totalCostWithFees).toLocaleString()}</p>
                      </div>
                    </div>
                    <p style={{fontWeight: 'bold', marginTop: '10px'}}>
                      {calculationData.totalCostWithFees < calculationData.comparisonData.totalCostWithFees 
                        ? `${calculationData.feeStructure === 'upfrontFee' ? '融資手数料型' : '融資金利上乗せ型'}の方が¥${Math.round(calculationData.comparisonData.totalCostWithFees - calculationData.totalCostWithFees).toLocaleString()}お得です`
                        : `${calculationData.feeStructure === 'upfrontFee' ? '融資金利上乗せ型' : '融資手数料型'}の方が¥${Math.round(calculationData.totalCostWithFees - calculationData.comparisonData.totalCostWithFees).toLocaleString()}お得です`
                      }
                      <span style={{fontSize: '11px', fontWeight: 'normal', color: '#6c757d', display: 'block', marginTop: '4px'}}>
                        ※この比較は概算であり、実際の条件や市場環境により異なる場合があります
                      </span>
                    </p>
                  </>
                )}
              </>
            )}
          </div>
          <RepaymentChart data={calculationData.repayments} />
          <BalanceChart data={calculationData.balanceOverTime} />
        </>
      )}
    </div>
  );
}

export default App;
